module.exports = __webpack_public_path__ + "static/media/Wikly.ja.75421846.svg";